import type { ParametersUnit } from "@/lib/api";

export type FormatParameterDisplayValueOptions = {
  rainDecimals?: 1 | 2;
};

/** Shared value + unit formatting for chart tooltips and map markers. */
export function formatParameterDisplayValue(
  value: string | number | undefined | null,
  unit?: ParametersUnit,
  options: FormatParameterDisplayValueOptions = {},
): string | null {
  if (unit?.code === "okta") return `${Math.round(Number(value ?? 0) * 10) / 10}/8`;

  if (value === undefined || value === null) return null;

  const parsedValue = Number(value);
  if (Number.isNaN(parsedValue)) return null;

  const rainDecimals = options.rainDecimals ?? 2;
  const decimals =
    unit && ["millimeter", "millimeter_per_hour"].includes(unit.code) ? rainDecimals : 1;
  const power = Math.pow(10, decimals);
  const roundedValue = Math.round(parsedValue * power) / power;

  return `${roundedValue}${unit?.symbol ?? ""}`;
}
